import _ from 'lodash';
import { orderIterations } from 'common/utils/utils';
import { getFilteredterationsTableData } from '../../../../../services/project-management.service';
import { FILTER_TYPES } from 'common/constants/filters';

export const getIterationsTableData = ({
  filteredIterations,
  providerBoardsMap = [],
  dbBoardsMap,
  onIterationSelection
}) =>
  orderIterations(filteredIterations).map(iteration => {
    return getFilteredterationsTableData(
      iteration,
      onIterationSelection,
      providerBoardsMap,
      dbBoardsMap
    );
  });

export const formatFiltersFromDB = (
  selectedFiltersOrigin = {},
  fixVersions = []
) => {
  const selectedFilters = {};

  for (const [key, value] of Object.entries(
    _.omit(selectedFiltersOrigin, FILTER_TYPES.FIELD, [])
  )) {
    selectedFilters[key] = value.map(item => ({
      id: item.provider_id || item.name,
      title: item.name || item.provider_key || item.provider_id,
      ...(item.provider_key && { key: item.provider_key })
    }));
  }

  const newSelectedCustomFields = _.get(
    selectedFiltersOrigin,
    FILTER_TYPES.FIELD,
    []
  ).map(field => ({
    id: field.id,
    value: field.value.map(value => ({ id: value, title: value }))
  }));

  for (let i = 0; i < newSelectedCustomFields.length; i++) {
    selectedFilters[newSelectedCustomFields[i].id] =
      newSelectedCustomFields[i].value;
  }

  return selectedFilters;
};

export const JIRA_FILTER_TYPES_MENU_ITEMS = [
  { title: 'Jira Board', id: FILTER_TYPES.BOARD },
  {
    title: 'Epic',
    id: FILTER_TYPES.EPIC,
    disabled: false,
    isWithIcon: true
  },
  {
    title: 'Label',
    id: FILTER_TYPES.LABEL,
    disabled: false,
    isWithIcon: true
  },
  {
    title: 'Field',
    id: FILTER_TYPES.FIELD,
    disabled: false,
    isWithIcon: true
  }
];
